function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import dc from 'dc';
import * as d3 from 'd3';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { TileMixin } from '../Mixins/TileMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
import './RowChart.scss';
export var RowChart = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RowChart, _React$Component);

  function RowChart(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "xAxisLabel", function (chartToUpdate, displayText) {
      var textSelection = chartToUpdate.svg().append('text').attr('class', 'x-axis-label').attr('text-anchor', 'middle').attr('x', chartToUpdate.width() / 2).attr('y', chartToUpdate.height() - 10).text(displayText);
      var textDims = textSelection.node().getBBox();
      var chartMargins = chartToUpdate.margins();
      textSelection.attr('x', chartMargins.left + (chartToUpdate.width() - chartMargins.left - chartMargins.right) / 2).attr('y', chartToUpdate.height() - Math.ceil(textDims.height) / 2);
    });

    _defineProperty(_assertThisInitialized(_this), "yAxisLabel", function (chartToUpdate, displayText) {
      var textSelection = chartToUpdate.svg().append('text').attr('class', 'y-axis-label').attr('text-anchor', 'middle').attr('transform', 'rotate(-90)').attr('x', -chartToUpdate.height() / 2).attr('y', 10).text(displayText);
      var textDims = textSelection.node().getBBox();
      var chartMargins = chartToUpdate.margins();
      textSelection.attr('x', -chartMargins.top - (chartToUpdate.height() - chartMargins.top - chartMargins.bottom) / 2).attr('y', Math.max(Math.ceil(textDims.height), chartMargins.left - Math.ceil(textDims.height) - 5));
    });

    _this.chartRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.onCrossfilterChange = _this.onCrossfilterChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = RowChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.attachFixedBarHeight = function attachFixedBarHeight(chart) {
    if (chart === void 0) {
      chart = null;
    }

    chart = chart || this.chart;

    if (this.props.fixedBarHeight) {
      chart.selectAll('g.row  text').transition().duration(0).style('dominant-baseline', 'auto').attr('y', this.props.fixedBarHeight / 2);
    }
  };

  _proto.attachAlign = function attachAlign(chart) {
    if (chart === void 0) {
      chart = null;
    }

    chart = chart || this.chart;

    if (this.props.titleAlign) {
      if (this.props.titleAlign === 'right') {
        chart.selectAll('g.row  text').transition().duration(0).attr('transform', "translate(" + chart.effectiveWidth() + ",0)").attr('x', -1 * this.props.labelOffsetX).attr('text-anchor', 'end');
      } else if (this.props.titleAlign === 'left') {
        chart.selectAll('g.row  text').transition().duration(0).attr('transform', 'translate(0,0)');
      }
    }
  };

  _proto.attachVeritcalLine = function attachVeritcalLine(chart) {
    if (chart === void 0) {
      chart = null;
    }

    chart = chart || this.chart;

    if (this.props.rowVerticalLine) {
      var x_vert = 0;
      var extra_data = [{
        x: chart.x()(x_vert),
        y: 0
      }, {
        x: chart.x()(x_vert),
        y: chart.effectiveHeight()
      }];
      var line = d3.line().x(function (d) {
        return d.x;
      }).y(function (d) {
        return d.y;
      }).curve(d3.curveLinear);
      var chartBody = chart.select('g');
      chartBody.selectAll('path.oeExtra').remove();
      var path = chartBody.selectAll('path.extra').data([extra_data]);
      path = path.enter().append('path').attr('class', 'oeExtra').attr('stroke', 'red').attr('id', 'oeLine').attr('stroke-width', 1).style('stroke-dasharray', '10,3').merge(path);
      path.attr('d', line);
    } else {
      var _chartBody = chart.select('g');

      _chartBody.selectAll('path.oeExtra').remove();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _this$props = this.props,
        elasticX = _this$props.elasticX,
        fixedBarHeight = _this$props.fixedBarHeight,
        gap = _this$props.gap,
        labelOffsetX = _this$props.labelOffsetX,
        labelOffsetY = _this$props.labelOffsetY,
        renderTitleLabel = _this$props.renderTitleLabel,
        titleLabelOffsetX = _this$props.titleLabelOffsetX,
        renderLabel = _this$props.renderLabel,
        label = _this$props.label,
        x = _this$props.x,
        xAxisLabel = _this$props.xAxisLabel,
        yAxisLabel = _this$props.yAxisLabel;
    this.chart = dc.rowChart(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    MarginsMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    this.chart.elasticX(elasticX).height(this.height).fixedBarHeight(fixedBarHeight).gap(gap).labelOffsetX(labelOffsetX).labelOffsetY(labelOffsetY).renderTitleLabel(renderTitleLabel).titleLabelOffsetX(titleLabelOffsetX).label(label).renderLabel(renderLabel).x(x).on('pretransition', function (chart) {
      _this2.attachFixedBarHeight(chart);

      _this2.attachAlign(chart);

      _this2.attachVeritcalLine();

      _this2.xAxisLabel(chart, xAxisLabel);

      _this2.yAxisLabel(chart, yAxisLabel);
    }).on('renderlet', function (chart) {
      _this2.attachFixedBarHeight(chart);

      _this2.attachAlign(chart);
    }).on('postRender', function (chart) {
      _this2.attachFixedBarHeight(chart);

      _this2.attachAlign(chart);

      _this2.xAxisLabel(chart, xAxisLabel);

      _this2.yAxisLabel(chart, yAxisLabel);
    }).on('filtered', function (chart) {
      _this2.attachFixedBarHeight(chart);

      _this2.attachAlign(chart);
    }).render();
    this.removeCrossfilterOnChange = this.props.crossfilter && this.props.crossfilter.onChange(this.onCrossfilterChange);

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeCrossfilterOnChange) this.removeCrossfilterOnChange();

    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.onCrossfilterChange = function onCrossfilterChange(eventName) {
    if (eventName === 'dataAdded') {
      this.chart.height(this.height).render();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    if (prevProps.crossfilter !== this.props.crossfilter) {
      if (this.removeCrossfilterOnChange) this.removeCrossfilterOnChange();
      this.removeCrossfilterOnChange = this.props.crossfilter.onChange(this.onCrossfilterChange);
    }

    if (prevProps.crossfilter !== this.props.crossfilter || prevProps.group !== this.props.group || prevProps.dimension !== this.props.dimension || prevProps.label !== this.props.label) {
      this.chart.height(this.height).dimension(this.props.dimension).group(this.props.group).render();
    }

    if (prevProps.orderFn !== this.props.orderFn) {
      this.chart._computeOrderedGroups = function (data) {
        return data.slice().sort(_this3.props.orderFn);
      };

      this.chart.render();
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart row-chart",
      ref: this.chartRef
    }));
  };

  _createClass(RowChart, [{
    key: "height",
    get: function get() {
      var _this$props2 = this.props,
          group = _this$props2.group,
          fixedBarHeight = _this$props2.fixedBarHeight,
          gap = _this$props2.gap;

      if (fixedBarHeight) {
        var margins = this.chart.margins();
        return group.size() * (fixedBarHeight + gap) + margins.top + margins.bottom;
      }

      return null;
    }
  }]);

  return RowChart;
}(React.Component);

_defineProperty(RowChart, "defaultProps", {
  elasticX: true,
  fixedBarHeight: false,
  gap: 5,
  labelOffsetX: 10,
  labelOffsetY: 10,
  renderTitleLabel: false,
  titleLabelOffsetX: 2,
  x: d3.scaleBand(),
  renderLabel: true,
  label: function label(d) {
    return d.key + " ( " + d.value + " )";
  },
  rowVerticalLine: false,
  titleAlign: null
});

RowChart.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Get or set the elasticity on x axis. If this attribute is set to true, then the x axis will rescale to auto-fit the data range when filtered. */
  elasticX: PropTypes.bool,

  /** Get or set the fixed bar height. Default is [false] which will auto-scale bars. For example, if you want to fix the height for a specific number of bars (useful in TopN charts) you could fix height as follows (where count = total number of bars in your TopN and gap is your vertical gap space). */
  fixedBarHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),

  /** Get or set the vertical gap space between rows on a particular row chart instance. */
  gap: PropTypes.number,

  /** Get or set the x offset (horizontal space to the top left corner of a row) for labels on a particular row chart. */
  labelOffsetX: PropTypes.number,

  /** Get or set the y offset (vertical space to the top left corner of a row) for labels on a particular row chart. */
  labelOffsetY: PropTypes.number,

  /** Turn on/off Title label rendering (values) using SVG style of text-anchor 'end'. */
  renderTitleLabel: PropTypes.bool,

  /** Get of set the x offset (horizontal space between right edge of row and right edge or text. */
  titleLabelOffsetX: PropTypes.number,

  /** Gets or sets the x scale. The x scale can be any d3 d3.scale.  */
  x: PropTypes.func,

  /** chartTitle */
  chartTitle: PropTypes.string,

  /** renderLabel */
  renderLabel: PropTypes.bool,

  /** label function. Example `label={function(d) { return d.key + '(' + d.value +  ')'}}` */
  label: PropTypes.func,

  /** Key name of the chart used by `AVIDashboardContext` in terms of the mapping name and id in the `register` method */
  name: PropTypes.string,

  /** Should row vertical line and x=0 be shown, most used in examples with possible negative values example https://dc-js.github.io/dc.js/examples/row-vertical-line.html */
  rowVerticalLine: PropTypes.bool,

  /** Align of the title */
  titleAlign: PropTypes.oneOf([null, 'left', 'right']),

  /** Get or set an accessor to order ordinal dimensions. The chart uses crossfilter.quicksort.by to sort elements; this accessor returns the value to order on. */
  ordering: PropTypes.func,

  /** Set order function, to control sorting */
  orderFn: PropTypes.func,

  /** Set the margins for a particular coordinate grid chart instance. The margins is stored as array. */
  margins: PropTypes.array,

  /** Set the x axis label. */
  xAxisLabel: PropTypes.string,

  /** Set the y axis label. */
  yAxisLabel: PropTypes.string
} : {};
export default withAVIDashboardContext(RowChart);